import React, { useState } from "react";
import { KeyPersonnelProject } from "types/key-personnel.types";
import { cn, formatCurrency } from "utils/helpers";
import { ProjectDetailModal } from "./ProjectDetailModal";

type ProjectInfoItemProps = {
	isLast?: boolean;
	label: string;
	value: string;
};

type PersonnelProjectCardProps = {
	index: number;
	project: KeyPersonnelProject;
};

const ProjectInfoItem = ({
	label,
	value,
	isLast = false,
}: ProjectInfoItemProps) => (
	<div
		className={`flex justify-between gap-2 py-2 [&_p]:text-sm ${isLast ? "pb-0" : ""}`}
	>
		<p className="text-gray-text-400">{label}</p>
		<p className="text-right font-semibold text-text-primary-900">{value}</p>
	</div>
);

export const PersonnelProjectCard = ({
	project,
	index,
}: PersonnelProjectCardProps) => {
	const [modalIsOpen, setModalIsOpen] = useState(false);

	const openModal = () => {
		if (project.isCompanyProject) {
			setModalIsOpen(true);
		}
	};

	const closeModal = () => {
		setModalIsOpen(false);
	};

	return (
		<>
			<div
				key={`${project.name}-${index}`}
				className={`overflow-hidden rounded-md border border-transparent bg-white shadow-md transition-all duration-300 ${project.isCompanyProject ? "cursor-pointer hover:border-border-primary hover:bg-gray-utility-100" : ""}`}
				onClick={openModal}
			>
				<div className="relative flex items-center justify-between">
					<div
						className={cn(
							"absolute left-0 top-0 h-[6px] w-full",
							project.isCompanyProject ? "bg-royal-blue2" : "bg-orange-500"
						)}
					></div>
					<div className="w-full space-y-8 p-6">
						<h3 className="text-xl font-semibold text-text-primary-900">
							{project.name}
						</h3>
						<div className="divide-y-[1px] divide-solid divide-quarternary-400">
							<ProjectInfoItem
								label="Primary Sector"
								value={project.sector?.name || "-"}
							/>
							<ProjectInfoItem
								label="Role"
								value={project.role || "-"}
							/>
							<ProjectInfoItem
								label="Location"
								value={project.location.value || "-"}
							/>
							<ProjectInfoItem
								label="Project Value"
								value={
									project.value_humanized ||
									formatCurrency(project.value) ||
									"0"
								}
								isLast={true}
							/>
						</div>
					</div>
				</div>
			</div>

			{project.isCompanyProject && (
				<ProjectDetailModal
					isOpen={modalIsOpen}
					onClose={closeModal}
					project={project}
				/>
			)}
		</>
	);
};
